import UsedCar from '@stories/Components/UsedCar/UsedCar';
import * as React from 'react';
import S from './VehicleSummary.styles';
const VehicleSummary = (props) => {
    return (React.createElement(S.Container, { id: props.id },
        React.createElement(S.Inner, null,
            React.createElement(S.ContentWrapper, null,
                React.createElement(S.Title, { level: "h2" }, props.title),
                props.content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } })),
            React.createElement(S.SummaryWrapper, null, props.vehicle && React.createElement(UsedCar, { ...props.vehicle, listView: true })))));
};
export default VehicleSummary;
